/* ---------------------------------------------------------------------------
   THE ONLY FILE YOU EDIT TO GO LIVE.
   Paste your Google Drive links here. Nothing else in the project needs touching.

   For each PDF in Drive: Share -> Anyone with the link -> Copy link.
   That gives you  https://drive.google.com/file/d/FILE_ID/view?usp=sharing
   Paste the whole thing. The portal turns it into a direct download by itself.
--------------------------------------------------------------------------- */

/* Where the email from the gate is recorded.
   Google Apps Script -> Deploy -> Web app -> Anyone. Paste the /exec URL. */
export const EMAIL_ENDPOINT = ''

/* Checkout links for the two locked sections. */
export const CHECKOUT = {
  videos: '',        // Shopify or Stripe link for the video pack
  videoPrice: '$37', // shown on the unlock button
  community: '',     // waitlist or checkout link, leave empty for email-only waitlist
}

export const FILES = {
  books: {
    1: 'https://drive.google.com/file/d/1R7G_vpGZBUyj8khFc87veQFjYNE8n6x4/view?usp=sharing',
    2: 'https://drive.google.com/file/d/1rF9bii9uajdqPHOqiecq4fIhgwEV0O5b/view?usp=sharing',
    3: 'https://drive.google.com/file/d/1SZF6_DlJa9RCJUwNnncvn0BSoog3Zcev/view?usp=sharing',
    4: 'https://drive.google.com/file/d/1aPSORUPyk00Ex8DFqyqA36n2Qsf2LvHX/view?usp=sharing',
    5: 'https://drive.google.com/file/d/1gPL2k3_I2p26Ite8gPgSV5gNXH5Sykmx/view?usp=sharing',
    6: 'https://drive.google.com/file/d/1XetMgfI_AgtL9lqFpyGeBcu-5LrP3-Zo/view?usp=sharing',
    7: 'https://drive.google.com/file/d/1HLbwHA04C9I-FCAgZlnh6yVSH34zYRy8/view?usp=sharing',
    8: 'https://drive.google.com/file/d/1MfY5HjzocF44wzVuG6KaDOjMyq9jBacH/view?usp=sharing',
    9: 'https://drive.google.com/file/d/1UY6LBdAKUuLnqoJYsie0oFp7Twrj7uot/view?usp=sharing',
    10: 'https://drive.google.com/file/d/1y4g7l-U8QUHOCOxkj4HvxBsHIuH8J-lw/view?usp=sharing',
    11: 'https://drive.google.com/file/d/1J6ZHj9Zi8sBHwyWpKvHu8SUDkjVrwjx4/view?usp=sharing',
    12: 'https://drive.google.com/file/d/11Obi3tZ3WFEg_kf-kbSBsyqa5f6QRNc7/view?usp=sharing',
  } as Record<number, string>,
  quickstart: {
    'qs-1': '', 'qs-2': '', 'qs-3': '', 'qs-4': '', 'qs-5': '',
  } as Record<string, string>,
  /* Mission Cards and The Cardboard Heist moved out of the bonus stack and
     became post-purchase upsells. Their delivery gets built separately. */
  upsells: {
    'mission-cards': '', 'cardboard-heist': '',
  } as Record<string, string>,
  everything: '', // optional: one folder or zip with all twelve
}

/* Cover images. Upload the twelve JPGs to Shopify -> Settings -> Files,
   then paste each cdn.shopify.com URL here. Empty is fine: the card falls
   back to a typeset spine in the book's own colour. */
export const COVERS: Record<number, string> = {
  1: '', 2: '', 3: '', 4: '', 5: '', 6: '',
  7: '', 8: '', 9: '', 10: '', 11: '', 12: '',
}

/* Bonus artwork, keyed by bonus number.

   These point at the CDN that generated them, which works today and cost
   nothing to set up, but it is not a bucket we control. When you next do an
   upload pass, put the ten JPGs in Shopify -> Settings -> Files and paste the
   cdn.shopify.com URLs over these. Nothing else has to change.

   If any URL ever stops resolving the card falls back to a typeset panel
   rather than showing a broken image. */
export const BONUS_COVERS: Record<string, string> = {
  '01': 'https://d8j0ntlcm91z4.cloudfront.net/user_372wM7Z8MnNYNWKOMOu9IfXotzL/hf_20260913_031140_06d598ef-a748-4c3a-be2d-544142b44bea_min.webp',
  '02': 'https://d8j0ntlcm91z4.cloudfront.net/user_372wM7Z8MnNYNWKOMOu9IfXotzL/hf_20260913_031140_c3ecb0fc-d725-4b97-b937-d61a5342eec9_min.webp',
  '03': 'https://d8j0ntlcm91z4.cloudfront.net/user_372wM7Z8MnNYNWKOMOu9IfXotzL/hf_20260913_031140_7be317fa-9c0d-41e0-93ae-836f356b1905_min.webp',
  '04': 'https://d8j0ntlcm91z4.cloudfront.net/user_372wM7Z8MnNYNWKOMOu9IfXotzL/hf_20260913_031140_81a759dd-5716-4379-9bc1-bedf60079e7b_min.webp',
  '05': 'https://d8j0ntlcm91z4.cloudfront.net/user_372wM7Z8MnNYNWKOMOu9IfXotzL/hf_20260913_031140_e9f90746-8276-46fa-9044-515281c93fc4_min.webp',
  '06': 'https://d8j0ntlcm91z4.cloudfront.net/user_372wM7Z8MnNYNWKOMOu9IfXotzL/hf_20260913_031510_6c21f581-f6ba-40b5-93c8-ce5d095bcf64_min.webp',
  '07': 'https://d8j0ntlcm91z4.cloudfront.net/user_372wM7Z8MnNYNWKOMOu9IfXotzL/hf_20260913_031416_bd5a0770-b1be-4c4c-8094-2d77ec6481b5_min.webp',
  '08': 'https://d8j0ntlcm91z4.cloudfront.net/user_372wM7Z8MnNYNWKOMOu9IfXotzL/hf_20260913_031204_4abdc186-0eb6-477a-9cdf-b582b11b6862_min.webp',
  '09': 'https://d8j0ntlcm91z4.cloudfront.net/user_372wM7Z8MnNYNWKOMOu9IfXotzL/hf_20260913_031204_ada89346-7e77-488c-bad0-60da249bfd2a_min.webp',
  '10': 'https://d8j0ntlcm91z4.cloudfront.net/user_372wM7Z8MnNYNWKOMOu9IfXotzL/hf_20260913_031204_5ded1675-744c-4f66-b1ed-b34429f14dcb_min.webp',
}

const driveId = (url: string) => url.match(/\/file\/d\/([a-zA-Z0-9_-]+)/)?.[1] ?? ''

/* Opens the file in Drive's own viewer. This is the primary action: the
   customer sees the book straight away instead of a 7 MB file landing
   somewhere they cannot find it on a phone. */
export function toView(url: string): string {
  if (!url) return ''
  const id = driveId(url)
  return id ? `https://drive.google.com/file/d/${id}/view` : url
}

/* Drive renders the first page of any public PDF as an image. That first page
   is the book cover, so the grid gets the real artwork with nothing to upload
   and nothing inlined, and it stays in step if you ever replace a PDF. */
export function toThumb(url: string, width = 600): string {
  if (!url) return ''
  const id = driveId(url)
  return id ? `https://drive.google.com/thumbnail?id=${id}&sz=w${width}` : ''
}

/* Starts the download immediately. Kept as the secondary action for
   anyone on a laptop who just wants the file. */
export function toDirect(url: string): string {
  if (!url) return ''
  const id = driveId(url)
  return id ? `https://drive.google.com/uc?export=download&id=${id}` : url
}
